/**
 * Definition for different customer statuses
 */
export var CUSTOMER_STATUS;
(function (CUSTOMER_STATUS) {
  CUSTOMER_STATUS["ACTIVE"] = "ACTIVE";
  CUSTOMER_STATUS["INACTIVE"] = "INACTIVE";
  CUSTOMER_STATUS["SUSPENDED"] = "SUSPENDED";
  CUSTOMER_STATUS["ARCHIVED"] = "ARCHIVED";
  CUSTOMER_STATUS["LEAD"] = "LEAD";
  CUSTOMER_STATUS["PENDING"] = "PENDING";
})(CUSTOMER_STATUS || (CUSTOMER_STATUS = {}));